import { JAB } from '../cards/attack/jab';
import { GUARD } from '../cards/defense/guard';
import { TOXIC_DART } from '../cards/support/toxic-dart';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Common tier: 2×2, 2 dice. The tutorial slug —
 * chips for 3, sometimes blocks, sometimes a one-turn poison. The "learn to
 * block" encounter; every card is acceptable on its own for the random-valid AI. */
export const MUD_CRAWLER: EnemyTemplate = {
  id: 'mud-crawler',
  name: 'Mud Crawler',
  glyph: '⌇', // wavy slime trail
  tier: 'common',
  hp: 12,
  loadout: [
    { card: JAB, origin: { row: 0, col: 0 }, rotated: false },
    { card: GUARD, origin: { row: 0, col: 1 }, rotated: false },
    { card: TOXIC_DART, origin: { row: 1, col: 0 }, rotated: false },
  ],
  drops: { gold: 3 },
};
